const promoSubText =
  'Assemble your crew, Add your tasks, Share your experiences. Track your progress and motivate each other. Start your group journey here.';

export const AppInvitationLink = 'https://woosladev.page.link/invitation';
export const Strings = {
  Login: {
    promoText: 'Organize your Journeys',
    subText: promoSubText,
  },
  Invite: {
    mailto: `mailto:?subject=Woosla Account Invitation&body=${promoSubText} \n${AppInvitationLink}`,
  },
};
